import { createContext } from "react";

/**
 * The conversation currently on screen. File downloads are scoped to it: /file requires the chat a
 * file belongs to, and the backend only serves it to that chat's owner. Inline "/file?fileId=..."
 * links stored in message text predate that requirement and carry no chat id, so the id comes from
 * here rather than from the link.
 */
export const ChatIdContext = createContext<string | undefined>(undefined);
